// extracted by mini-css-extract-plugin
export default {"ReadonlyCommentBoxContainer":"ReadonlyCommentBox-module__ReadonlyCommentBoxContainer--lfHCu","centeredContent":"ReadonlyCommentBox-module__centeredContent--gg_W2"};